import { Link } from '@dev-spendesk/grapes';
import { Trans } from 'react-i18next';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { TypeGuardError } from 'src/core/utils/switchGuard';

import { type Integration } from '../../../types';
import { getHelpCenter, isKomboIntegration } from '../../../utils';

type Props = {
  integration: Integration;
};

export const IntegrationHelpCenter = (props: Props) => {
  const { integration } = props;
  const { t } = useTranslation('global');

  if (isKomboIntegration(integration.id)) {
    return null;
  }

  switch (integration.id) {
    case 'travelperk':
      return (
        <div className="flex w-full flex-col gap-8 text-left">
          <span className="text-content-primary title-m">
            {t('integration.connection.howToUse.title')}
          </span>
          <p className="text-content-secondary-bg-primary">
            <Trans i18nKey="integration.connection.howToUse.helpCenterArticle">
              text
              <Link
                className="text-content-primary"
                isExternal
                href={getHelpCenter(integration.id)}
                rel="noreferrer"
              >
                link
              </Link>
              text
            </Trans>
          </p>
        </div>
      );
    case 'spendesk-oauth2':
    case 'wise':
      return null;
    default:
      throw new TypeGuardError(
        integration.id,
        'IntegrationHelpCenterInModal: Unknown integrationId',
      );
  }
};
